import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';

const responsiveEmbedCss = ":host{position:relative;box-sizing:border-box}:host *,:host *:before,:host *:after{box-sizing:inherit}:host{display:block}.responsive-embed{position:relative}.responsive-embed ::slotted(embed),.responsive-embed ::slotted(iframe),.responsive-embed ::slotted(object){position:absolute !important;top:0 !important;left:0 !important;width:100% !important;height:100% !important}";

const ResponsiveEmbed = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.aspectRatio = '16:9';
  }
  handleAspectRatioChange() {
    this.setAspectRatio();
  }
  connectedCallback() {
    this.handleSlotChange = this.handleSlotChange.bind(this);
  }
  handleSlotChange() {
    this.setAspectRatio();
  }
  setAspectRatio() {
    const split = this.aspectRatio.split(':');
    const x = parseInt(split[0]);
    const y = parseInt(split[1]);
    this.base.style.paddingBottom = x && y ? `${(y / x) * 100}%` : '';
  }
  render() {
    return (h("div", { ref: (el) => {
        if (el)
          this.base = el;
      }, part: "base", class: "responsive-embed" }, h("slot", { onSlotchange: this.handleSlotChange })));
  }
  static get watchers() { return {
    "aspectRatio": ["handleAspectRatioChange"]
  }; }
  static get style() { return responsiveEmbedCss; }
}, [1, "sl-responsive-embed", {
    "aspectRatio": [1, "aspect-ratio"]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["sl-responsive-embed"];
  components.forEach(tagName => { switch (tagName) {
    case "sl-responsive-embed":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, ResponsiveEmbed);
      }
      break;
  } });
}

const SlResponsiveEmbed = ResponsiveEmbed;
const defineCustomElement = defineCustomElement$1;

export { SlResponsiveEmbed, defineCustomElement };
